<template>
  <div>
    <form @submit.prevent="submit">
      <div class="form-group form-row">
        <div class="col-6">
          <FloatingLabel type="text" input-class="form-control form-control-xl bg-light-2 border-0" label="Nombre" v-model="firstName" v-on:blur="checkName" />
          <small class="form-text text-danger" v-if="nameMessage">{{ nameMessage }}</small>
        </div>

        <div class="col-6">
          <FloatingLabel type="text" input-class="form-control form-control-xl bg-light-2 border-0" label="Apellido" v-model="lastName" />
        </div>
      </div>

      <div class="form-group">
        <FloatingLabel type="email" input-class="form-control form-control-xl bg-light-2 border-0" label="Correo electrónico" v-model="email" v-on:blur="checkEmail.length > 0 && checkEmailConfirm()" />
        <small class="form-text text-danger" v-if="emailMessage">{{ emailMessage }}</small>
      </div>

      <div class="form-group">
        <FloatingLabel type="email" input-class="form-control form-control-xl bg-light-2 border-0" label="Repita su correo electrónico" v-model="emailConfirm" v-on:blur="checkEmailConfirm" />
        <small class="form-text text-danger" v-if="emailConfirmMessage">{{ emailConfirmMessage }}</small>
      </div>

      <!-- <div class="form-group" v-show="!$store.state.deviseTrying.hasOwnProperty('isForeign')">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="foreign" v-model="isForeign">
          <label class="custom-control-label" for="foreign">Sou estrangeiro</label>
        </div>
      </div> -->

      <div class="form-group" v-show="!$store.state.deviseTrying.hasOwnProperty('document')">
        <input v-if="!isForeign" type="text" class="form-control form-control-xl bg-light-2 border-0" placeholder="CPF" required v-model="document" @blur="checkDocument" v-mask="'###.###.###-##'" />
        <input v-if="isForeign" type="text" class="form-control form-control-xl bg-light-2 border-0" :placeholder="pageCountry == 'mexico' ? 'CURP' : 'Documento Nacional de Identidad'" required v-model="document" @blur="checkDocument" v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXX'" />

        <small class="form-text text-danger" v-if="documentMessage">{{ documentMessage }}</small>
      </div>

      <div class="form-group form-row">
        <div class="col-6">
          <FloatingLabel type="password" input-class="form-control form-control-xl bg-light-2 border-0" label="Contraseña" v-b-tooltip.focus="'Tu contraseña debe tener al menos 8 caracteres'" v-model="password" v-on:blur="passwordConfirm.length > 0 && checkPasswordConfirm()" />
        </div>

        <div class="col-6">
          <FloatingLabel type="password" input-class="form-control form-control-xl bg-light-2 border-0" label="Repita su contraseña"  v-model="passwordConfirm" v-on:blur="checkPasswordConfirm" />
          <small class="form-text text-danger" v-if="passwordConfirmMessage">{{ passwordConfirmMessage }}</small>
        </div>
      </div>

      <vue-recaptcha
        class="d-flex justify-content-center"
        :loadRecaptchaScript="true"
        sitekey="6LexzmQUAAAAACSwQGT6QOH_1yrY7xYdkvnG9Dvj"
        @verify="recaptchaVerify"
        @expired="recaptchaExpired"
        language="es"
      ></vue-recaptcha>

      <p class="text-muted mt-5 mb-3 text-center semi-small">Al continuar, acepta la recopilación y el uso de datos personales con el único propósito de reclutamiento y selección.</p>

      <div class="text-center mt-3">
        <a href="#" class="text-blue-ml font-weight-bold mr-3" @click.prevent="$emit('changeModal', 'login')">Atrás para iniciar sesión</a>
        <button type="submit" class="btn btn-blue-ml px-4" :disabled="!canSubmit">Iniciar mi registro</button>
      </div>
    </form>
  </div>
</template>

<script>
  import VueRecaptcha from "vue-recaptcha"
  import FloatingLabel from '@/components/FloatingLabel';

  export default {
    name: 'RegisterForm',

    data(){
      return {
        firstName: '',
        lastName: '',
        email: '',
        emailConfirm: '',
        isForeign: true,
        document: this.$store.state.deviseTrying.document || '',
        password: '',
        passwordConfirm: '',
        recaptchaChecked: false,
        nameMessage: null,
        emailMessage: null,
        documentMessage: null,
        passwordConfirmMessage: null,
        emailConfirmMessage: null
      }
    },

    computed: {
      canSubmit() {
        return  this.firstName.length > 2 &&
                this.lastName.length > 2 &&
                this.$helpers.isEmail(this.email) &&
                (
                  (this.isForeign && this.document.length > 5) ||
                  (!this.isForeign && this.$helpers.isCPF(this.document))
                ) &&
                this.$helpers.validPassword(this.password) &&
                this.email == this.emailConfirm &&
                this.password == this.passwordConfirm &&
                this.recaptchaChecked
      },

      pageCountry() {
        if (this.$route.fullPath.includes('brasil')) return 'brasil'
        if (this.$route.fullPath.includes('mexico')) return 'mexico'
      }
    },

    components: {
      VueRecaptcha,
      FloatingLabel
    },

    watch: {
      // Limpa documento quando muda a flag de estrangeiro
      isForeign: function(newValue, oldValue) {
        this.document = ''
        this.documentMessage = null
      },
    },

    methods: {
      checkName(){
        this.nameMessage = this.firstName.length > 2 ? null : 'Nombre muy corto';
      },

      checkEmail(){
        this.emailMessage = this.$helpers.isEmail(this.email) ? null : 'Email inválido';
      },

      checkEmailConfirm() {
        this.emailConfirmMessage = this.email == this.emailConfirm ? null : 'Diferentes correos electrónicos';
      },

      checkDocument() {
        if ( !this.isForeign ) {
          this.documentMessage = this.$helpers.isCPF(this.document) ? null : 'CPF inválido';
        } else {
          this.documentMessage = this.document.length > 5 ? null : 'Documento inválido'
        }
      },

      checkPasswordConfirm() {
        this.passwordConfirmMessage = this.password == this.passwordConfirm ? null : 'Diferentes contraseñas';
      },

      recaptchaVerify() {
        this.recaptchaChecked = true
      },

      recaptchaExpired() {
        this.recaptchaChecked = false
      },

      submit() {
        let current_profile = this.$store.state.deviseTrying;

        current_profile.first_name = this.firstName;
        current_profile.last_name = this.lastName;
        current_profile.email = this.email;
        current_profile.isForeign = this.isForeign;
        current_profile.document = this.document;
        current_profile.password = this.password;
        current_profile.provider = null;
        current_profile.id = null;

        this.$store.commit('DEVISE_TRYING', current_profile);
        this.$emit('signUp');
      }
    }
  }
</script>

<style lang="scss"></style>
